import { useTenantStore } from '../../stores/useTenantStore';
import { useErrorStore } from '../../stores/useErrorStore';
import { NormalisedErrorItem } from '../../stores/useErrorStore';

import { Availability } from '../../types/tenant';
import useErrorNavigation from './useErrorNavigation';
import { RequestType, RequestTypeShort } from '../../types';

export function useRequestFormAvailability() {
  const tenantStore = useTenantStore();
  const errorStore = useErrorStore();
  const errorNavigation = useErrorNavigation();

  async function check(storeIdShort: RequestType): Promise<Availability | null> {
    const formStatus = await tenantStore.fetchRequestFormStatus(
      storeIdShort.replace('-request', '') as RequestTypeShort,
    );

    if (
      formStatus.availabilityStatus === 'closed' ||
      formStatus.availabilityStatus === 'paused' ||
      formStatus.availabilityStatus === 'disabled'
    ) {
      const error: NormalisedErrorItem = {
        code: 'patient-portal-form-closed',
        requestType: storeIdShort,
      };

      errorStore.setErrors([error]);

      await errorNavigation.navigateToErrorPage();

      return null;
    }

    return formStatus;
  }

  return {
    check,
  };
}
